module.exports = __webpack_public_path__ + "static/media/hero-image.93fc25a0.jpg";